<template lang="pug">
    .home
        .wrap
            .index 
                p 家谱作为家族文化和历史的重要载体，具有深厚的意义和价值。它记录了一个家族的起源、发展和变迁，反映了一个家族的文化传承、人文素养和社会地位。通过研究家谱，我们可以了解家族的历史和文化传承，从而更好地认识和理解自己的家族和祖先。家谱也是了解家族成员关系、族谱宗谱的重要资料，对于研究家族史、族谱学和家族文化等领域有着重要的参考价值。
                p 家谱是家族成员凝聚感情、传承文化的纽带，也是后代了解祖先、了解自己的重要渠道。家谱可以帮助我们更好地了解自己的身世和家族文化，增强对家族的认同感和归属感，促进家族成员之间的沟通和交流。同时，家谱也可以传承家族的优良传统和精神，激励家族成员继承和发扬先辈的优良传统和精神，促进家族凝聚和团结。 
                p 家谱的编写和传承是一项具有历史、文化、社会和人文价值的重要工作，有助于维护和传承家族文化，促进社会和谐稳定。通过家谱的编写和传承，我们可以传承家族的文化传统和精神财富，增强民族凝聚力和文化自信心，也为社会和谐稳定做出了积极的贡献。
            .poetry
                .li 世代相传，纵贯古今，
                .li 家谱记载，血脉相连。
                .li 祖祖辈辈，传承不息，
                .li 悠悠岁月，历史沉淀。
                <p>

        .ICP
            .li Copyright © 2024 河南酷追科技有限公司 | <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">豫公网安备41019702003488号</a> | <a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备2024046990号-2</a>
</template>

<script>

    import marked from 'marked';
    export default {
        components:{
        },
        data () {
            return {
                tabArr: ["关于我们","使用帮助","协议条款"],
                tabInd: this.$route.query.tab || 1,
                about: null,
                help: null,
                terms: null,
            }
        },
        mounted(){

        },
        computed: {
        },
        created(){

        },
        methods:{

            getData(){
                this.$get('cdn/document/about.md').then((res) =>{
                    if(res){
                        this.about = res?marked(res):null
                    }
                }).catch(err => {
                });
                this.$get('cdn/document/help.md').then((res) =>{
                    if(res){
                        this.help = res?marked(res):null
                    }
                }).catch(err => {
                });
                this.$get('cdn/document/terms.md').then((res) =>{
                    if(res){
                        this.terms = res?marked(res):null
                    }
                }).catch(err => {
                });
            },

        },
        watch: {

        },
        activated(){
            this.tabInd = this.$route.query.tab||1;
            this.getData()
        },
        deactivated(){

        }
    }
</script>
